import React from "react";
import './ContactSource.css';
import Contacts01 from "../../../static/img/Contacts/Contacts01.png";
import Contacts02 from "../../../static/img/Contacts/Contacts02.svg";
import Contacts03 from "../../../static/img/Contacts/Contacts03.svg";
import LayoutMain from "../../../Elements/LayoutMain/LayoutMain";
import IfYouHaveQuestions from "../../../Elements/LayoutMain/IfYouHaveQuestions/IfYouHaveQuestions";

function ContactSource (props) {
    function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
    } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}
      return (
          <LayoutMain title={props.title} description={props.description} lang={props.lang} AllMenu={['ElementMenuActive','','','','','']} Active={0}>
              <main className="ContactPage">
                  <div className="StandartIn">
                      <div className="StandartTitleOut StandartTitleTop">
                          <div className="ContactPageTitle"><TextSource lang = {props.lang} ArrIndex= 'Contact0000'>Contacts</TextSource></div>
                          {props.Adminka ? <div/> : <IfYouHaveQuestions lang={props.lang}/>}
                      </div>

                      <div className="ContactPageTop">
                          <div className="ContactPageTopLeft">
                              <img src={Contacts01} className="ContactPageTopLeftIMG"  alt='Ifyoudontseeimages' width='120px'/>
                              <div className="ContactPageTopLeftTitle"><TextSource lang = {props.lang} ArrIndex= 'Contact0005'>Оnline assistant</TextSource> </div>
                              <div className="ContactPageTopLeftText"><TextSource lang = {props.lang} ArrIndex= 'Contact0010'>оn all questions </TextSource></div>
                          </div>
                          <div className="ContactPageTopRight">
                              <div className="ContactPageTopRightIn">
                                  <div className="ContactPageTopRightTop"><TextSource lang = {props.lang} ArrIndex= 'Contact0015'>COMPANY DATA</TextSource></div>
                                  <div className="ContactPageTopRightTitle"><TextSource lang = {props.lang} ArrIndex= 'Contact0020'>TIM GROUP INC.</TextSource></div>
                                  <div className="ContactPageTopRightText">
                                      <TextSource lang = {props.lang} ArrIndex= 'Contact0025'>Corner Hutson & Eyre Street, Suite 302,</TextSource><br/>
                                      <TextSource lang = {props.lang} ArrIndex= 'Contact0030'>Blake Building Belize City, Belize</TextSource>
                                  </div>

                              </div>
                          </div>
                      </div>
                      <div className="ContactPageElements">
                          <div className="ContactPageElement">
                              <div className="ContactPageElementTitle"><TextSource lang = {props.lang} ArrIndex= 'Contact0035'>Financial Department</TextSource></div>
                              <div className="ContactPageElementText"><TextSource lang = {props.lang} ArrIndex= 'Contact0040'>Financial questions (deposits and withdrawals)</TextSource> </div>
                              <div className="ContactPageElementEmail">
                                  <img src={Contacts02}  alt='Ifyoudontseeimages' width='21px'/>
                                  <div className="ContactPageElementEmailText">finance@profiforex.com</div>

                              </div>
                              <div className="ContactPageElementClock">
                                  <img src={Contacts03} alt='Ifyoudontseeimages' width='20px'/>
                                  <div className="ContactPageElementClockText"><TextSource lang = {props.lang} ArrIndex= 'Contact0045'>7 a.m. - 4 p.m. London time (Mon-Fri)</TextSource></div>
                              </div>
                          </div>
                          <div className="ContactPageElement">
                              <div className="ContactPageElementTitle"><TextSource lang = {props.lang} ArrIndex= 'Contact0050'>Client Department</TextSource></div>
                              <div className="ContactPageElementText"><TextSource lang = {props.lang} ArrIndex= 'Contact0055'>General and technical questions</TextSource></div>
                              <div className="ContactPageElementEmail">
                                  <img src={Contacts02} className="AdvantagesTerminals01"  alt='Ifyoudontseeimages' width='21px'/>
                                  <div className="ContactPageElementEmailText">support@profiforex.com</div>

                              </div>
                              <div className="ContactPageElementClock">
                                  <img src={Contacts03} className="AdvantagesTerminals01"  alt='Ifyoudontseeimages' width='20px'/>
                                  <div className="ContactPageElementClockText">24-hour</div>
                              </div>
                          </div>
                          <div className="ContactPageElement">
                              <div className="ContactPageElementTitle"><TextSource lang = {props.lang} ArrIndex= 'Contact0060'>Development Department</TextSource></div>
                              <div className="ContactPageElementText"><TextSource lang = {props.lang} ArrIndex= 'Contact0065'>Partnership program (questions on commission fees for agents)</TextSource> </div>
                              <div className="ContactPageElementEmail">
                                  <img src={Contacts02} className="AdvantagesTerminals01"  alt='Ifyoudontseeimages' width='21px'/>
                                  <div className="ContactPageElementEmailText">partner@profiforex.com</div>

                              </div>
                              <div className="ContactPageElementClock">
                                  <img src={Contacts03} className="AdvantagesTerminals01"  alt='Ifyoudontseeimages' width='20px'/>
                                  <div className="ContactPageElementClockText">24-hour</div>
                              </div>
                          </div>

                      </div>
                  </div>
              </main>
          </LayoutMain>

        )}

export default ContactSource